module.exports = [{"type":"hash","text":"取消訂閱"},{"type":"normal","text":"取消訂閱的格式如下："},{"type":"code","text":"{ \"id\": \"id1\", \"reqType\": \"unsub\", \"dataType\": \"data to unsub\"}"},{"type":"normal","text":"取消訂閱成功確認："},{"type":"code","text":"{ \"id\": \"id1\", \"code\": 0, \"msg\": \"\" }"},{"type":"html","text":"<h3>symbol說明</h3>"},{"type":"warning","text":"symbol必須全大寫"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce/06_cancel_subscribe.json
// module id = 8PHc
// module chunks = 3